<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.physicalExams', 1) }} to {{ $tc('message.prenatalConsultations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group
                            id="prenatalConsultationInformation-group"
                            :label="$tc('message.prenatalConsultations', 1)"
                            label-for="prenatalConsultationInformation"
                    >
                        <b-form-input
                                id="prenatalConsultationInformation"
                                v-model="prenatalConsultationInformation"
                                type="text"
                                disabled
                                placeholder=""
                        ></b-form-input>

                        <b-form-invalid-feedback>
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>
                        <span v-if="errorshasField('consultation')" style="color:red">
                                    {{getErrorsField('consultation')}}
                                    </span>
                    </b-form-group>
                    <b-form-group
                            id="multiple-group"
                            :label="$t('message.select')+' '+$tc('message.physicalExams', 2)"
                            label-for="multiple-0">
                        <!-- Options -->
                        <select id="multiple" multiple v-model="form.examensClinique" @change="clearErrorField('examensClinique')">
                            <option v-for="item in mPhysicals" :value="item.id">
                                {{ item.reference }}
                            </option>
                        </select>
                        <span v-if="errorshasField('examensClinique')" style="color:red">
                                    {{getErrorsField('examensClinique')}}
                                    </span>
                    </b-form-group>
                    <b-form-group
                            id="physicalExaminations-group"
                            :label="$tc('message.physicalExams', 1)"
                            label-for="physicalExamination-0">
                        <b-input-group
                                v-for="(physicalExamination, index) in physicalExaminations"
                                :key="index"
                                :class="{ 'mt-3': index }"
                        >
                            <b-form-input
                                    :id="`physicalExamination-${ index }`"
                                    :value="physicalExamination"
                                    v-model="physicalExaminations[index]"
                                    @keydown="clearErrorField('examensCliniqueACreer')"
                            ></b-form-input>

                            <b-input-group-append>
                                <b-button
                                        v-if="!physicalExaminations[index] || physicalExaminations[index].length < 2"
                                        disabled
                                        variant="primary">
                                    {{ $t('message.add') }}
                                </b-button>

                                <b-button
                                        v-else
                                        @click="addPhysicalExaminationField(index)"
                                        variant="primary">
                                    {{ $t('message.add') }}
                                </b-button>

                                <b-button
                                        @click="removePhysicalExaminationField(index)"
                                        variant="danger"
                                        v-if="index">
                                    {{ $t('message.remove') }}
                                </b-button>
                            </b-input-group-append>
                            <span v-if="errorshasField('examensCliniqueACreer')" style="color:red">
                                    {{getErrorsField('examensCliniqueACreer')}}
                                    </span>
                        </b-input-group>
                    </b-form-group>


                    <b-button type="submit" variant="primary">
                        {{ $t('message.add') }}
                    </b-button>

<!--                    <b-button type="reset" variant="danger">-->
<!--                        {{ $t('message.reset') }}-->
<!--                    </b-button>-->
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import SlimSelect from 'slim-select';
    import { mapGetters } from 'vuex';
    import _ from 'lodash';

    export default {
        name: "AddPhysicalExamsToPrenatalConsultation",
        computed: {
            ...mapGetters(["prenatalConsultation","physicalExams",'errors']),
            prenatalConsultationInformation :function(){
                return this.prenatalConsultation.type_de_consultation;
            },
            mPhysicals: function() {
                let eArray = [];

                _.forEach(this.physicalExams, function(exam) {
                    let e = {};

                    e.reference = exam.reference;
                    if(exam.description){
                        e.description = exam.description.length > 20 ? exam.description.substr(0, 20) + '...' : exam.description;
                    }else{
                        e.description = ''
                    }
                    e.id = exam.id;

                    eArray.push(e);
                });

                return eArray;
            },
        },
        data() {
            return {
                consultation_id: this.$route.params.consultation,
                form: {
                    examensClinique: [],
                },
                show: true,
                physicalExaminations: ['']
            }
        },
        methods: {
            addPhysicalExaminationField: function(index) {
                if (this.physicalExaminations[index] && this.physicalExaminations[index].length >= 2) {
                    this.physicalExaminations.push('');
                }
            },
            removePhysicalExaminationField: function(index) {
                this.physicalExaminations.splice(index, 1);
            },
            getPhysicalExams() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPhysicalExams', { args : args });
            },

            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getPrenatalConsultation", { args });
            },
            onSubmit: function(evt) {
                evt.preventDefault();

                if (this.form.examensClinique.length >0 || this.physicalExaminations.length >0){
                    if(this.physicalExaminations.length >0){
                        let longueur = this.physicalExaminations.length -1;
                        if((this.physicalExaminations[longueur]).length ==0){
                            this.physicalExaminations.splice(longueur, 1);
                        }
                    }
                    // if(!this.$v.$invalid) {
                    let args = {
                        consultation: this.prenatalConsultation.id,
                        examensClinique: this.form.examensClinique.length >0 ? this.form.examensClinique : null,
                        examensCliniqueACreer:this.physicalExaminations.length >0 ?this.physicalExaminations : null
                    };

                    let successMessage = this.$i18n.t('message.physicalExamAdded');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('addPrenatalConsultationPhysicalExam', { args, errorMessages, successMessage });
                    // }
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                // this.form.reference = '';
                // this.form.description = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors.hasOwnProperty(field);
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },
        mounted() {
            this.getConsultation();
            this.getPhysicalExams();

            new SlimSelect({
                select: '#multiple',
                placeholder: 'Select Physical examination'
            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>